var map = {
	"./11.jpg": 1216,
	"./12.jpg": 1217,
	"./13.jpg": 1218,
	"./14.jpg": 1219,
	"./15.jpg": 1220,
	"./16.jpg": 1221,
	"./17.jpg": 1222,
	"./18.jpg": 1223,
	"./19.jpg": 1224,
	"./20.jpg": 1225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 542;